import { graphql } from "~/gql";

export const BEDROCK_TEST_EMBEDDINGS_QUERY = graphql(/* GraphQL */ `
  query TestEmbeddings {
    testEmbeddings
  }
`);
